export const campaignFormFields = [
    {
        name: 'jobId',
        label: 'Campaign Name',
        type: 'text',
        required: true,
        placeholder: 'Enter Campaign Name',
        className: 'campaignName',
        rules: {
            maxLength: {
                value: 64,
                message: "Maximum 64 characters are allowed.",
            },
            pattern: {
                value: /^[a-zA-Z0-9-_]+$/,
                message: "Only alphabets, numbers, hyphens(-) or underscores(_) allowed. (No spaces)",
            }
        },
    },
    {
        name: 'expiryDays',
        label: 'Campaign Expiry',
        type: 'select',
        required: true,
        placeholder: 'Select expiry',
        className: 'campaignExpiryDays',
        options: Array.from({ length: 10 }, (_, i) => ({
            value: i + 1,
            label: `${i + 1} Day${i + 1 > 1 ? 's' : ''}`,
        })),
    },
    {
        name: 'otaArtifactId',
        label: 'OTA Artifacts',
        type: 'select',
        required: true,
        placeholder: 'Select OTA Artifact',
        className: 'otaArtifacts',
        options: [],
    },
    {
        name: 'targetMode',
        label: 'Target Devices',
        type: 'radio',
        defaultValue: 'ALL_DEVICES',
        className: 'campaignTargetMode',
        options: [
            { value: 'ALL_DEVICES', label: 'All Devices' },
            { value: 'SPECIFIC_DEVICES', label: 'Specific Devices' },
        ],
    },
    {
        name: 'targetDeviceIds',
        label: 'Select Devices',
        type: 'asyncSelect',
        isMulti: true,
        required: true,
        placeholder: 'Select an OTA Artifact first',
        className: 'campaignTargetDevices',
        loadOptions: null,
        cacheKey: null,
        selectProps: {
            onBlurResetsInput: false,
            formatOptionLabel: (option) =>
                option.userAssignedDeviceName ? (
                    <span>
                        {option.userAssignedDeviceName}{' '}
                        <small style={{ fontSize: '0.8em', color: '#6c757d' }}>
                            ({option.thingName})
                        </small>
                    </span>
                ) : (
                    option.thingName
                ),
        },
        visibleIf: (values) => values.targetMode === 'SPECIFIC_DEVICES',
        disabledIf: (values) => !values.otaArtifactId,
        rules: {
            validate: (value) => (Array.isArray(value) && value.length > 0) || 'Please select at least one device',
        },
    },
    {
        name: 'description',
        label: 'Description',
        type: 'textarea',
        rows: '3',
        required: false,
        placeholder: 'Enter Description',
        className: 'campaignDescription',
        rules: {
            maxLength: {
                value: 255,
                message: "Maximum 255 characters are allowed.",
            }
        }
    }
];
